export const DUMP_TYPES = {
  PROJECT_CREATION: 'PROJECT_CREATION',
  PART_CREATION: 'PART_CREATION',
  CLEAR: 'CLEAR',
};

export const projectCreationDump = (data) => {
  return function (dispatch) {
    dispatch({
      type: DUMP_TYPES.PROJECT_CREATION,
      payload: data,
    });
  };
};

export const partCreationDump = (data) => {
  return function (dispatch) {
    dispatch({
      type: DUMP_TYPES.PART_CREATION,
      payload: data,
    });
  };
};

export const clearDumpAction = (fieldName) => {
  return function (dispatch) {
    dispatch({
      type: DUMP_TYPES.CLEAR,
      payload: fieldName,
    });
  };
};
